import { Button, Input } from '@platform/components';
import { Control, Controller, FieldArrayPath, FieldValues, useFieldArray } from 'react-hook-form';

export const FormBlock = ({ header, children }: { header: string; children: React.ReactNode }) => {
  return (
    <div className='bg-white p-4 flex flex-col gap-6'>
      <h2 className='font-header text-2xl font-semibold text-gray-500'>{header}</h2>
      {children}
    </div>
  );
};

/* A dynamic list of short text inputs backed by a `{ value: string }[]` field array, used
 * to collect one or more free-form deliverables for a project. */
export const DeliverablesList = <TFieldValues extends FieldValues>({
  control,
  fieldKey,
}: {
  control: Control<TFieldValues>;
  fieldKey: FieldArrayPath<TFieldValues>;
}) => {
  const { fields, append, remove } = useFieldArray({ control, name: fieldKey });

  return (
    <div className='flex flex-col gap-2'>
      {fields.map((field, i) => (
        <div key={field.id} className='flex items-center gap-2'>
          <div className='w-full'>
            <Controller
              control={control}
              name={`${fieldKey}.${i}.value` as FieldArrayPath<TFieldValues>}
              render={({ field: inputField }) => (
                <Input
                  type='inline'
                  value={inputField.value as string}
                  onChange={inputField.onChange}
                  maxLength={160}
                />
              )}
            />
          </div>
          <Button
            onClick={() => remove(i)}
            isDisabled={fields.length <= 1}
            variant='tertiary-gray'
            size='sm'
            leadIcon='trash-01'
            leadIconClassNames='stroke-error-500'
          >
            <></>
          </Button>
        </div>
      ))}
      {fields.length < 10 && (
        <Button
          onClick={() => append({ value: '' } as never)}
          variant='link-color'
          size='sm'
          additionalClassnames='self-start'
          leadIcon='plus-circle'
        >
          Add deliverable
        </Button>
      )}
    </div>
  );
};
